import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("lawork-lang") || "pt";
    }
    return "pt";
  });

  const changeLang = useCallback((next) => {
    setLang(next);
    if (typeof window !== "undefined") {
      localStorage.setItem("lawork-lang", next);
    }
  }, []);

  const toggleLang = useCallback(() => {
    changeLang(lang === "pt" ? "en" : "pt");
  }, [lang, changeLang]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
